// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"927adc39","590":"44c22d4a","651":"6f8d87ae","677":"5a44331f","847":"23b43171","897":"bdc9b27a","977":"3930d37f"}[chunkId] + ".chunk.js";
};